import { IAbsenceWarning, TAbsenceWarningMoment } from 'shared/domain/entities';

export interface IVectisAbsenceWarning {
  exibirAviso: boolean;
  momento: TAbsenceWarningMoment | null;
  texto: string | null;
  textoFormatado?: string | null;
  quantidadeAtual: number;
  limite: number | null;
  titulo: string | null;
  rotuloAceite: string | null;
  erroAoCarregar: string | null;
  erroAoConfirmar: string | null;
}

export class AbsenceWarning implements IAbsenceWarning {
  public shouldShow: IAbsenceWarning['shouldShow'];
  public moment: IAbsenceWarning['moment'];
  public message: IAbsenceWarning['message'];
  public currentCount: IAbsenceWarning['currentCount'];
  public limit: IAbsenceWarning['limit'];
  public title: IAbsenceWarning['title'];
  public acceptanceLabel: IAbsenceWarning['acceptanceLabel'];
  public loadErrorMessage: IAbsenceWarning['loadErrorMessage'];
  public confirmErrorMessage: IAbsenceWarning['confirmErrorMessage'];

  constructor({
    exibirAviso,
    momento,
    texto,
    textoFormatado,
    quantidadeAtual,
    limite,
    titulo,
    rotuloAceite,
    erroAoCarregar,
    erroAoConfirmar,
  }: IVectisAbsenceWarning) {
    this.shouldShow = exibirAviso;
    this.moment = momento;
    this.message = textoFormatado ?? texto;
    this.currentCount = quantidadeAtual;
    this.limit = limite;
    this.title = titulo;
    this.acceptanceLabel = rotuloAceite;
    this.loadErrorMessage = erroAoCarregar;
    this.confirmErrorMessage = erroAoConfirmar;
  }
}
